import LandingBgImageMobile from "../../assets/images/2018/mobile/headers/Landingpage_Header_New.png";
import HowBgImageMobile from "../../assets/images/2018/mobile/headers/HowItWorks_Header_new.png";
import Step1BgImageMobile from "../../assets/images/2018/mobile/headers/Step1_Header_new.png";
import Step2BgImageMobile from "../../assets/images/2018/mobile/headers/Step2_Header_new.png";
import Step3BgImageMobile from "../../assets/images/2018/mobile/headers/Step3_Header_new.png";
import Step4BgImageMobile from "../../assets/images/2018/mobile/headers/Step4_Header_new.png";
import Step5BgImageMobile from "../../assets/images/2018/mobile/headers/Step5_Header_new.png";
import Step6BgImageMobile from "../../assets/images/2018/mobile/headers/Step6_Header_new.png";
import ContactBgImageMobile from "../../assets/images/2018/mobile/headers/Contact_Header_new.png";
import FaqBgImageMobile from "../../assets/images/2018/mobile/headers/Faq_Header_new.png";
import LegalBgImageMobile from "../../assets/images/2018/mobile/headers/Legal_Header_new.png";
import MissionBgImageMobile from "../../assets/images/2018/mobile/headers/Mission_Header_new.png";

import LandingBgImageDesktop from "../../assets/images/2018/desktop/headers/Landingpage_Header_New.png";
import HowBgImageDesktop from "../../assets/images/2018/desktop/headers/HowItWorks_Header_new.png";
import Step1BgImageDesktop from "../../assets/images/2018/desktop/headers/Step1_Header_new.png";
import Step2BgImageDesktop from "../../assets/images/2018/desktop/headers/Step2_Header_new.png";
import Step3BgImageDesktop from "../../assets/images/2018/desktop/headers/Step3_Header_new.png";
import Step4BgImageDesktop from "../../assets/images/2018/desktop/headers/Step4_Header_new.png";
import Step5BgImageDesktop from "../../assets/images/2018/desktop/headers/Step5_Header_new.png";
import Step6BgImageDesktop from "../../assets/images/2018/desktop/headers/Step6_Header_new.png";
import ContactBgImageDesktop from "../../assets/images/2018/desktop/headers/Contact_Header_new.png";
import FaqBgImageDesktop from "../../assets/images/2018/desktop/headers/Faq_Header_new.png";
import LegalBgImageDesktop from "../../assets/images/2018/desktop/headers/Legal_Header_new.png";
import MissionBgImageDesktop from "../../assets/images/2018/desktop/headers/Mission_Header_new.png";

export default {
  mobile: {
    "/": LandingBgImageMobile,
    "/how": HowBgImageMobile,
    "/proceed": Step1BgImageMobile,
    "/details/personal": Step2BgImageMobile,
    "/details/target": Step3BgImageMobile,
    "/details/response": Step3BgImageMobile,
    "/message": Step4BgImageMobile,
    "/payment": Step5BgImageMobile,
    "/review": Step6BgImageMobile,
    "/mission": MissionBgImageMobile,
    "/faq": FaqBgImageMobile,
    "/legal": LegalBgImageMobile,
    "/contact": ContactBgImageMobile,
    "/response/*": LandingBgImageMobile
  },
  desktop: {
    "/": LandingBgImageDesktop,
    "/how": HowBgImageDesktop,
    "/proceed": Step1BgImageDesktop,
    "/details/personal": Step2BgImageDesktop,
    "/details/target": Step3BgImageDesktop,
    "/details/response": Step3BgImageDesktop,
    "/message": Step4BgImageDesktop,
    "/payment": Step5BgImageDesktop,
    "/review": Step6BgImageDesktop,
    "/mission": MissionBgImageDesktop,
    "/faq": FaqBgImageDesktop,
    "/legal": LegalBgImageDesktop,
    "/contact": ContactBgImageDesktop,
    "/response/*": LandingBgImageDesktop
  }
};



// WEBPACK FOOTER //
// ./components/Controls/Backgrounds.js